
import styled from "styled-components";

export const InputStyled = styled.div`
  display: flex;
  padding: var(--Sizes---size-xs, 4px);
  align-items: center;
  align-self: stretch;
  border-radius: var(--Sizes-borderRadiusInput, 32px);
  border: 1px solid var(--Text-Colors-neutral, rgba(24, 55, 68, 0.50));
  transition: border-color 0.3s;
  width: 100%;

  &:focus-within {
    border-color: ${({ theme }) => theme?.colors?.theme?.brandColor3 || "blue"};
  }

  input {
    flex: 1 0;
    width: 100%;
    background: transparent;
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    padding: 8px;
    font-size: 14px;
    color: ${({ theme }) => theme?.colors?.text?.neutral || "black"};
  }

  button {

    padding: 4px 16px;
  }
`;
